import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import Button from '../../../../Button'
import { FieldStackedLabel } from '../../../../Field'
import {
  FormBody,
  FormFieldsContainer,
  useFormValidationErrorsNotification,
} from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  RECOVER_PASSWORD_FORM_EMAIL_MAX_LENGTH,
  RECOVER_PASSWORD_FORM_FIELD_HEIGHT,
  RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL,
} from '../RecoverPasswordForm.constants'

import * as styles from './RecoverPasswordFormFields.module.css'

function RecoverPasswordFormFields({
  onRemoveNotification,
  onSetNotification,
}) {
  const { isSubmitting } = useFormikContext()

  const { t } = useTranslation()

  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody Actions={null} Header={null}>
      <FormFieldsContainer className={styles.formFields}>
        <FormikField
          Component={InputField}
          Field={FieldStackedLabel}
          disabled={isSubmitting}
          height={RECOVER_PASSWORD_FORM_FIELD_HEIGHT}
          label={t('Auth.RecoverPasswordEmailLabelKey')}
          maxLength={RECOVER_PASSWORD_FORM_EMAIL_MAX_LENGTH}
          name={RECOVER_PASSWORD_FORM_FIELD_NAME_EMAIL}
          placeholder={t('Auth.RecoverPasswordEmailPlaceholderKey')}
        />
      </FormFieldsContainer>
      <Button.Contained
        className={styles.button}
        height={RECOVER_PASSWORD_FORM_FIELD_HEIGHT}
        isLoading={isSubmitting}
        text={t('Auth.RecoverPasswordSubmitBtnKey')}
        type='submit'
      />
    </FormBody>
  )
}

export default RecoverPasswordFormFields
